<template>
  <div class="tech-dropdown">
    <div class="tech-dropdown-toggle">
      <a href="javascript:void(0);" @click="ddToggle">
        <i class="material-icons-outlined align-middle">more_horiz</i>
      </a>
    </div>
    <div class="tech-dropdown-menu" v-show="params.data.ddOpen">
      <ul>
        <li>
          <a href="javascript:void(0);" @click="navTo('consultant_dashboard')">
            <i class="material-icons-outlined align-middle">dashboard</i>
            Dashboard
          </a>
        </li>
        <li>
          <a href="javascript:void(0);" @click="navTo('consultant_resume')">
            <i class="material-icons-outlined align-middle">assignment_ind</i>
            Resume
          </a>
        </li>
        <li>
          <a href="javascript:void(0);" @click="navTo('consultant_payment')">
            <i class="material-icons-outlined align-middle">payment</i>
            Payment
          </a>
        </li>
        <li>
          <a href="javascript:void(0);" @click="navTo('consultant_document')">
            <i class="material-icons-outlined align-middle">attach_file</i>
            Document
          </a>
        </li>
        <li>
          <a href="javascript:void(0);" @click="navToReview()">
            <i class="material-icons-outlined align-middle">article</i>
            Review
          </a>
        </li>
        <li class="divider"></li>
        <li>
          <a href="javascript:void(0);" @click="editConsultant">
            <i class="material-icons-outlined align-middle">edit</i>
            Edit
          </a>
        </li>
        <li>
          <a href="javascript:void(0);" @click="uploadResume">
            <i class="material-icons-outlined align-middle">upload</i>
            Upload
          </a>
        </li>
        <li>
          <a href="javascript:void(0);" @click="deleteTech">
            <i class="material-icons-outlined align-middle">delete</i>
            Delete
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isOpen() {
      return this.params.data.ddOpen;
    }
  },
  watch: {
    isOpen: function(val) {
      if (val) {
        let offset = this.$el.getBoundingClientRect();
        if (document.body.clientHeight - offset.top < 230) {
          this.$el.querySelector(".tech-dropdown-menu").style.top = "auto";
          this.$el.querySelector(".tech-dropdown-menu").style.bottom = "37px";
        } else {
          this.$el.querySelector(".tech-dropdown-menu").style.top = "40px";
          this.$el.querySelector(".tech-dropdown-menu").style.bottom = "auto";
        }
      }
    }
  },
  methods: {
    ddToggle: function() {
      this.params.data.ddOpen = !this.params.data.ddOpen;
      this.params.context.componentParent.openCurrentAgDropdown(
        this.params.data,
        this.$el
      );
    },
    navTo: function(path) {
      const routeData = this.$router.resolve({
        path: "/home/consultant/" + path,
        query: { id: this.params.data.id }
      });
      window.open(routeData.href, '_blank');
      this.params.context.componentParent.hideCurrentAgDropdown();
    },
    navToReview: function() {
      const routeData = this.$router.resolve({
        path: "/home/admin/consultant_review",
        query: { id: this.params.data.id }
      });
      window.open(routeData.href, '_blank');
    },
    editConsultant: function() {
      this.params.context.componentParent.editConsultant(this.params.data);
    },
    uploadResume: function() {
      this.params.context.componentParent.uploadResume(this.params.data);
    },
    deleteTech: function() {
      this.params.context.componentParent.deleteConsultant(this.params.data);
    },
    // TODO view as
    setTechUser: function() {
      this.$store.commit("setTechSlackId", this.params.data.slackId);
      this.$store.commit("setTechUserId", this.params.data.id);
      this.$store.commit("setTechUserName", this.params.data.name);
      this.$store.commit("setViewingAs", {
        role: "consultant",
        email: this.params.data.email,
        name: this.params.data.name,
        slackId: this.params.data.slackId,
        id: this.params.data.id,
        photoURL: this.params.data.photoURL,
        path: this.$router.currentRoute.path
      });
    }
  }
};
</script>
